import { z } from "zod";

// Enums

export type ClientIds = keyof typeof ClientIds;
export const ClientIds = { web: "web" } as const;

export const ClientIdsSchema = z.enum(["web"], {
  invalid_type_error: "Invalid Option",
});
export type ClientIdsSchema = z.infer<typeof ClientIdsSchema>;

export type CustomClaims = keyof typeof CustomClaims;
export const CustomClaims = {
  permissions: "permissions",
  role: "role",
} as const;

export const CustomClaimsSchema = z.enum(["permissions", "role"], {
  invalid_type_error: "Invalid Option",
});
export type CustomClaimsSchema = z.infer<typeof CustomClaimsSchema>;

export type CurrencyCodes = keyof typeof CurrencyCodes;
export const CurrencyCodes = { USD: "USD" } as const;

export const CurrencyCodesSchema = z.enum(["USD"], {
  invalid_type_error: "Invalid Option",
});
export type CurrencyCodesSchema = z.infer<typeof CurrencyCodesSchema>;

export type LogHandleStatuses = keyof typeof LogHandleStatuses;
export const LogHandleStatuses = {
  Resolved: "Resolved",
  Unresolved: "Unresolved",
} as const;

export const LogHandleStatusesSchema = z.enum(["Resolved", "Unresolved"], {
  invalid_type_error: "Invalid Option",
});
export type LogHandleStatusesSchema = z.infer<typeof LogHandleStatusesSchema>;

export type Timezones = keyof typeof Timezones;
export const Timezones = {
  "US/Pacific": "US/Pacific",
  "US/Mountain": "US/Mountain",
  "US/Central": "US/Central",
  "US/Eastern": "US/Eastern",
} as const;

export const TimezonesSchema = z.enum(
  ["US/Pacific", "US/Mountain", "US/Central", "US/Eastern"],
  { invalid_type_error: "Invalid Option" },
);
export type TimezonesSchema = z.infer<typeof TimezonesSchema>;

export type UtcOptions = keyof typeof UtcOptions;
export const UtcOptions = {
  "UTC -12": "UTC -12",
  "UTC -11": "UTC -11",
  "UTC -10": "UTC -10",
  "UTC -9": "UTC -9",
  "UTC -8": "UTC -8",
  "UTC -7": "UTC -7",
  "UTC -6": "UTC -6",
  "UTC -5": "UTC -5",
  "UTC -4": "UTC -4",
  "UTC -3": "UTC -3",
  "UTC -2": "UTC -2",
  "UTC -1": "UTC -1",
  "UTC +0": "UTC +0",
  "UTC +1": "UTC +1",
  "UTC +2": "UTC +2",
  "UTC +3": "UTC +3",
  "UTC +4": "UTC +4",
  "UTC +5": "UTC +5",
  "UTC +6": "UTC +6",
  "UTC +7": "UTC +7",
  "UTC +8": "UTC +8",
  "UTC +9": "UTC +9",
  "UTC +10": "UTC +10",
  "UTC +11": "UTC +11",
  "UTC +12": "UTC +12",
  "UTC +13": "UTC +13",
  "UTC +14": "UTC +14",
} as const;

export const UtcOptionsSchema = z.enum(
  [
    "UTC -12",
    "UTC -11",
    "UTC -10",
    "UTC -9",
    "UTC -8",
    "UTC -7",
    "UTC -6",
    "UTC -5",
    "UTC -4",
    "UTC -3",
    "UTC -2",
    "UTC -1",
    "UTC +0",
    "UTC +1",
    "UTC +2",
    "UTC +3",
    "UTC +4",
    "UTC +5",
    "UTC +6",
    "UTC +7",
    "UTC +8",
    "UTC +9",
    "UTC +10",
    "UTC +11",
    "UTC +12",
    "UTC +13",
    "UTC +14",
  ],
  { invalid_type_error: "Invalid Option" },
);
export type UtcOptionsSchema = z.infer<typeof UtcOptionsSchema>;

export type UriProtocols = keyof typeof UriProtocols;
export const UriProtocols = {
  "http://": "http://",
  "https://": "https://",
} as const;

export const UriProtocolsSchema = z.enum(["http://", "https://"], {
  invalid_type_error: "Invalid Option",
});
export type UriProtocolsSchema = z.infer<typeof UriProtocolsSchema>;

export type UserTitles = keyof typeof UserTitles;
export const UserTitles = {
  "Mr.": "Mr.",
  "Ms.": "Ms.",
  "Mrs.": "Mrs.",
  "Miss.": "Miss.",
  "Dr.": "Dr.",
} as const;

export const UserTitlesSchema = z.enum(["Mr.", "Ms.", "Mrs.", "Miss.", "Dr."], {
  invalid_type_error: "Invalid Option",
});
export type UserTitlesSchema = z.infer<typeof UserTitlesSchema>;

export type FilterOnOptions = keyof typeof FilterOnOptions;
export const FilterOnOptions = {
  Yes: "Yes",
  No: "No",
  Unknown: "Unknown",
} as const;

export const FilterOnOptionsSchema = z.enum(["Yes", "No", "Unknown"], {
  invalid_type_error: "Invalid Option",
});
export type FilterOnOptionsSchema = z.infer<typeof FilterOnOptionsSchema>;

export type CodeClassTypes = keyof typeof CodeClassTypes;
export const CodeClassTypes = {
  "Level of Service": "Level of Service",
  "Non Repairable Reasons": "Non Repairable Reasons",
  "Customer Rejection Reason": "Customer Rejection Reason",
  "Document Type": "Document Type",
  Disposition: "Disposition",
  OEM: "OEM",
  "Part Type": "Part Type",
  "Upper Connection": "Upper Connection",
  "Middle Connection": "Middle Connection",
  "Lower Connection": "Lower Connection",
  "Working Pressure": "Working Pressure",
  Service: "Service",
  "Part Name": "Part Name",
} as const;

export const CodeClassTypesSchema = z.enum(
  [
    "Level of Service",
    "Non Repairable Reasons",
    "Customer Rejection Reason",
    "Document Type",
    "Disposition",
    "OEM",
    "Part Type",
    "Upper Connection",
    "Middle Connection",
    "Lower Connection",
    "Working Pressure",
    "Service",
    "Part Name",
  ],
  { invalid_type_error: "Invalid Option" },
);
export type CodeClassTypesSchema = z.infer<typeof CodeClassTypesSchema>;

export type JobStatusTypes = keyof typeof JobStatusTypes;
export const JobStatusTypes = {
  Evaluation: "Evaluation",
  Archiving: "Archiving",
  "Closed - Archived": "Closed - Archived",
} as const;

export const JobStatusTypesSchema = z.enum(
  ["Evaluation", "Archiving", "Closed - Archived"],
  { invalid_type_error: "Invalid Option" },
);
export type JobStatusTypesSchema = z.infer<typeof JobStatusTypesSchema>;

export type JobTypes = keyof typeof JobTypes;
export const JobTypes = { "M&M": "M&M", "Non-M&M": "Non-M&M" } as const;

export const JobTypesSchema = z.enum(["M&M", "Non-M&M"], {
  invalid_type_error: "Invalid Option",
});
export type JobTypesSchema = z.infer<typeof JobTypesSchema>;

export type JobQuoteStatusTypes = keyof typeof JobQuoteStatusTypes;
export const JobQuoteStatusTypes = {
  "Quote Pending": "Quote Pending",
  "Pending Approval": "Pending Approval",
  "Quote Approved": "Quote Approved",
  "Quote Rejected": "Quote Rejected",
} as const;

export const JobQuoteStatusTypesSchema = z.enum(
  ["Quote Pending", "Pending Approval", "Quote Approved", "Quote Rejected"],
  { invalid_type_error: "Invalid Option" },
);
export type JobQuoteStatusTypesSchema = z.infer<
  typeof JobQuoteStatusTypesSchema
>;

export type FieldTypes = keyof typeof FieldTypes;
export const FieldTypes = {
  Checkbox: "Checkbox",
  Text: "Text",
  Number: "Number",
  Date: "Date",
} as const;

export const FieldTypesSchema = z.enum(["Checkbox", "Text", "Number", "Date"], {
  invalid_type_error: "Invalid Option",
});
export type FieldTypesSchema = z.infer<typeof FieldTypesSchema>;

export type DocumentTypes = keyof typeof DocumentTypes;
export const DocumentTypes = {
  NDE: "NDE",
  "NDE Recheck": "NDE Recheck",
  "Test Chart": "Test Chart",
  Certificate: "Certificate",
  "Blank Job Report": "Blank Job Report",
} as const;

export const DocumentTypesSchema = z.enum(
  ["NDE", "NDE Recheck", "Test Chart", "Certificate", "Blank Job Report"],
  { invalid_type_error: "Invalid Option" },
);
export type DocumentTypesSchema = z.infer<typeof DocumentTypesSchema>;

export type ReviewStatuses = keyof typeof ReviewStatuses;
export const ReviewStatuses = {
  "Pending Review": "Pending Review",
  "Request More Information": "Request More Information",
  "Review Completed": "Review Completed",
} as const;

export const ReviewStatusesSchema = z.enum(
  ["Pending Review", "Request More Information", "Review Completed"],
  { invalid_type_error: "Invalid Option" },
);
export type ReviewStatusesSchema = z.infer<typeof ReviewStatusesSchema>;

export type ReportNames = keyof typeof ReportNames;
export const ReportNames = {
  "evaluation-report-pdf": "evaluation-report-pdf",
  "job-form-pdf": "job-form-pdf",
  "scrap-report-mm-pdf": "scrap-report-mm-pdf",
  "scrap-report-pdf": "scrap-report-pdf",
  "cos-report-pdf": "cos-report-pdf",
  "cos-report-pdf-partner-site": "cos-report-pdf-partner-site",
  "uecoc-report-pdf": "uecoc-report-pdf",
  "uecoc-report-pdf-partner-site": "uecoc-report-pdf-partner-site",
  "daily-summary-report-pdf": "daily-summary-report-pdf",

  "monthly-rig-sn-report-pdf": "monthly-rig-sn-report-pdf",
  "monthly-partner-site-sn-report-pdf": "monthly-partner-site-sn-report-pdf",

  "repair-summary-report-pdf": "repair-summary-report-pdf",

} as const;

export const ReportNamesSchema = z.enum(
  [
    "evaluation-report-pdf",
    "job-form-pdf",
    "scrap-report-mm-pdf",
    "scrap-report-pdf",
    "cos-report-pdf",
    "cos-report-pdf-partner-site",
    "uecoc-report-pdf",
    "uecoc-report-pdf-partner-site",
    "daily-summary-report-pdf",

    "monthly-rig-sn-report-pdf",
    "monthly-partner-site-sn-report-pdf",

    "repair-summary-report-pdf",

  ],
  { invalid_type_error: "Invalid Option" },
);
export type ReportNamesSchema = z.infer<typeof ReportNamesSchema>;

export type DefaultPartnerSites = keyof typeof DefaultPartnerSites;
export const DefaultPartnerSites = {
  "M&M International": "M&M International",
} as const;

export const DefaultPartnerSitesSchema = z.enum(["M&M International"], {
  invalid_type_error: "Invalid Option",
});
export type DefaultPartnerSitesSchema = z.infer<
  typeof DefaultPartnerSitesSchema
>;

export type DefaultLevelOfServices = keyof typeof DefaultLevelOfServices;
export const DefaultLevelOfServices = { COS: "COS", UECOC: "UECOC" } as const;

export const DefaultLevelOfServicesSchema = z.enum(["COS", "UECOC"], {
  invalid_type_error: "Invalid Option",
});
export type DefaultLevelOfServicesSchema = z.infer<
  typeof DefaultLevelOfServicesSchema
>;

export type DateFormats = keyof typeof DateFormats;
export const DateFormats = { "MM/dd/yyyy": "MM/dd/yyyy" } as const;

export const DateFormatsSchema = z.enum(["MM/dd/yyyy"], {
  invalid_type_error: "Invalid Option",
});
export type DateFormatsSchema = z.infer<typeof DateFormatsSchema>;

export type TrackedSerialNumberServiceStatuses =
  keyof typeof TrackedSerialNumberServiceStatuses;
export const TrackedSerialNumberServiceStatuses = {
  Active: "Active",
  Inactive: "Inactive",
} as const;

export const TrackedSerialNumberServiceStatusesSchema = z.enum(
  ["Active", "Inactive"],
  { invalid_type_error: "Invalid Option" },
);
export type TrackedSerialNumberServiceStatusesSchema = z.infer<
  typeof TrackedSerialNumberServiceStatusesSchema
>;

export type ValidTestCodes = keyof typeof ValidTestCodes;
export const ValidTestCodes = {
  TEST3RD: "TEST3RD",
  TAPI10: "TAPI10",
  TAPI15: "TAPI15",
  TAPI225: "TAPI225",
  TAPIDUAL: "TAPIDUAL",
  TCUST: "TCUST",
  TDSES15: "TDSES15",
  TDSES225: "TDSES225",
  TDUALV: "TDUALV",
  TAPIIBOP: "TAPIIBOP",
  TPIS15: "TPIS15",
  TPIS225: "TPIS225",
  TSES10: "TSES10",
  TSES15: "TSES15",
  TSES225: "TSES225",
  TSTDIBOP: "TSTDIBOP",
  TSTDV: "TSTDV",
  TPIS10: "TPIS10",
  OTAPI15: "OTAPI15",
  OTAPI10: "OTAPI10",
  OTAPI225: "OTAPI225",
  OTAPIBOP: "OTAPIBOP",
  OTSTIBOP: "OTSTIBOP",
  OTSTDV: "OTSTDV",
  OTSES15: "OTSES15",
  OTDSES15: "OTDSES15",
  OTAPIDBL: "OTAPIDBL",
  OTPIS15: "OTPIS15",
} as const;

export const ValidTestCodesSchema = z.enum(
  [
    "TEST3RD",
    "TAPI10",
    "TAPI15",
    "TAPI225",
    "TAPIDUAL",
    "TCUST",
    "TDSES15",
    "TDSES225",
    "TDUALV",
    "TAPIIBOP",
    "TPIS15",
    "TPIS225",
    "TSES10",
    "TSES15",
    "TSES225",
    "TSTDIBOP",
    "TSTDV",
    "TPIS10",
    "OTAPI15",
    "OTAPI10",
    "OTAPI225",
    "OTAPIBOP",
    "OTSTIBOP",
    "OTSTDV",
    "OTSES15",
    "OTDSES15",
    "OTAPIDBL",
    "OTPIS15",
  ],
  { invalid_type_error: "Invalid Option" },
);
export type ValidTestCodesSchema = z.infer<typeof ValidTestCodesSchema>;

export type SignalRTopics = keyof typeof SignalRTopics;
export const SignalRTopics = { TestSignal: "TestSignal" } as const;

export const SignalRTopicsSchema = z.enum(["TestSignal"], {
  invalid_type_error: "Invalid Option",
});
export type SignalRTopicsSchema = z.infer<typeof SignalRTopicsSchema>;

export type SignalRConfig = keyof typeof SignalRConfig;
export const SignalRConfig = { "/signalr-hub": "/signalr-hub" } as const;

export const SignalRConfigSchema = z.enum(["/signalr-hub"], {
  invalid_type_error: "Invalid Option",
});
export type SignalRConfigSchema = z.infer<typeof SignalRConfigSchema>;

export type UserPermissions = keyof typeof UserPermissions;
export const UserPermissions = {
  "Users: View": "Users: View",
  "Users: Manage": "Users: Manage",
} as const;

export const UserPermissionsSchema = z.enum(["Users: View", "Users: Manage"], {
  invalid_type_error: "Invalid Option",
});
export type UserPermissionsSchema = z.infer<typeof UserPermissionsSchema>;

export type PartnerSitePermissions = keyof typeof PartnerSitePermissions;
export const PartnerSitePermissions = {
  "Partner Sites: View": "Partner Sites: View",
  "Partner Sites: Manage": "Partner Sites: Manage",
} as const;

export const PartnerSitePermissionsSchema = z.enum(
  ["Partner Sites: View", "Partner Sites: Manage"],
  { invalid_type_error: "Invalid Option" },
);
export type PartnerSitePermissionsSchema = z.infer<
  typeof PartnerSitePermissionsSchema
>;

export type ReviewInboxPermissions = keyof typeof ReviewInboxPermissions;
export const ReviewInboxPermissions = {
  "Review Inbox: Manage": "Review Inbox: Manage",
} as const;

export const ReviewInboxPermissionsSchema = z.enum(["Review Inbox: Manage"], {
  invalid_type_error: "Invalid Option",
});
export type ReviewInboxPermissionsSchema = z.infer<
  typeof ReviewInboxPermissionsSchema
>;

export type JobsPermissions = keyof typeof JobsPermissions;
export const JobsPermissions = {
  "Jobs: View": "Jobs: View",
  "Jobs: Manage": "Jobs: Manage",
} as const;

export const JobsPermissionsSchema = z.enum(["Jobs: View", "Jobs: Manage"], {
  invalid_type_error: "Invalid Option",
});
export type JobsPermissionsSchema = z.infer<typeof JobsPermissionsSchema>;

export type SerialNumberTrackingPermissions =
  keyof typeof SerialNumberTrackingPermissions;
export const SerialNumberTrackingPermissions = {
  "Serial Number Tracking: View": "Serial Number Tracking: View",
  "Serial Number Tracking: Manage": "Serial Number Tracking: Manage",
} as const;

export const SerialNumberTrackingPermissionsSchema = z.enum(
  ["Serial Number Tracking: View", "Serial Number Tracking: Manage"],
  { invalid_type_error: "Invalid Option" },
);
export type SerialNumberTrackingPermissionsSchema = z.infer<
  typeof SerialNumberTrackingPermissionsSchema
>;

export type Roles = keyof typeof Roles;
export const Roles = {
  "Partner Site Manager": "Partner Site Manager",
  "Partner Site User": "Partner Site User",
  "Serial Number Tracking User": "Serial Number Tracking User",
  "System User": "System User",
  "Global Admin": "Global Admin",
} as const;

export const RolesSchema = z.enum(
  [
    "Partner Site Manager",
    "Partner Site User",
    "Serial Number Tracking User",
    "System User",
    "Global Admin",
  ],
  { invalid_type_error: "Invalid Option" },
);
export type RolesSchema = z.infer<typeof RolesSchema>;

// Statics

export const RoleTemplates = {
  "Global Admin": [
    "Review Inbox: Manage",
    "Serial Number Tracking: View",
    "Serial Number Tracking: Manage",
  ],
  "Partner Site Manager": [
    "Users: View",
    "Users: Manage",
    "Serial Number Tracking: View",
    "Serial Number Tracking: Manage",
  ],
  "Serial Number Tracking User": [
    "Serial Number Tracking: View",
    "Serial Number Tracking: Manage",
    "Jobs: View",
  ],
} as const;

export const AllPermissions = [
  "Review Inbox: Manage",
  "Serial Number Tracking: View",
  "Serial Number Tracking: Manage",
] as const;
